import React, { useState } from "react";
import "../searchSchool/style.css";
import ResetBlack from "src/assets/reset-white.png";
import SearchIcon from "src/assets/iconsearch.png";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const SearchSchoolView = (props: any) => {
  const [selectedValue, setSelectedValue] = useState("name");
  const [searchTerm, setSearchTerm] = useState('');
  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
    setSearchTerm("")
  };
  // Function to handle the input change
  const handleInputChange = (event: any) => {
    setSearchTerm(event.target.value);
  };

  // Function to handle Enter key press
  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      props.onSubmit(selectedValue, searchTerm);
    }
  };
  return (
    <div className="seach-contain">
      <div className="filter-btn">
        <div className="selectOption">
          <select value={selectedValue} onChange={handleChange} style={{cursor: "pointer"}}>
            <option value="">Search By</option>
            <option value="name">School Name</option>
            <option value="email">Email</option>
            <option value="subscriptionType">Subscription</option>
          </select>
        </div>
        <div className="filter-btns">
          <button onClick={() => {
              setSelectedValue("name")
            setSearchTerm("")
            props.onSubmit('', '')
          }}>
            <img src={ResetBlack} />
          </button>
        </div>
      </div>
      {selectedValue && <div className="input-btn">
        {selectedValue !== "subscriptionType" ? <div className="input-content">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}   
            onChange={handleInputChange}
            onKeyDown={handleKeyPress} 
          />
        </div> : <div className="subscription-btn-subbtn">
          <FormControl variant="outlined" style={{ minWidth: 200 }}>
            <InputLabel id="dropdown-label">Select Subscription</InputLabel>
            <Select
              labelId="dropdown-label"
              value={searchTerm}
              onChange={handleInputChange}
              label="Select Subscription"
            >
              {/* <MenuItem value=""><em>None</em></MenuItem> */}
              <MenuItem value={'free'}>Free</MenuItem>
              <MenuItem value={'paid'}>Paid</MenuItem>
            </Select>
          </FormControl>
        </div>}
        <div className="search-btn">
          <button onClick={() => {
            props.onSubmit(selectedValue, searchTerm)
          }}>
            <img src={SearchIcon} />
          </button>

        </div>
      </div>}
    </div>
  );
};

export default SearchSchoolView;



// WEBPACK FOOTER //
// ./src/shared/components/searchSchool/index.tsx